module.exports = __webpack_public_path__ + "img/tag_fsyy.e0d95fd1.png";